/**
 * ResponsiveDialog — a MUI Dialog that goes full-screen on small viewports.
 *
 * MUI can't express "fullScreen on mobile" via theme defaultProps (it needs a
 * hook), so this thin wrapper is the canonical way to make any dialog usable on
 * phones. Drop-in replacement for <Dialog>: forwards every DialogProp and only
 * supplies `fullScreen` when the caller hasn't set it explicitly.
 */

import React from "react";
import {
  Dialog,
  useMediaQuery,
  useTheme,
  type DialogProps,
  type Breakpoint,
} from "@mui/material";

export interface ResponsiveDialogProps extends DialogProps {
  /** Below this breakpoint the dialog renders full-screen. Default "sm". */
  mobileBreakpoint?: Breakpoint;
}

export const ResponsiveDialog: React.FC<ResponsiveDialogProps> = ({
  mobileBreakpoint = "sm",
  fullScreen,
  ...props
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(mobileBreakpoint));
  return <Dialog fullScreen={fullScreen ?? isMobile} {...props} />;
};

export default ResponsiveDialog;
